<nz-layout class="backdrop">
  <nz-header>
    <div (click)="isHide = !isHide" class="alain-default__nav-item ant-menu-item hidden-desktop">
      <i [nzType]="isHide ? 'menu-unfold' : 'menu-fold'" nz-icon nzTheme="outline"></i>
    </div>
    <div class="logo">
      <img height="36" src="/assets/icon.png"/>
    </div>
    <div class="page-header">
      {{ title$ | async }}
      <ng-container *ngIf="subTitle$ | async  as sub">- {{ sub  }}</ng-container>
    </div>
    <div class="header">
      <nz-avatar [nzText]="init" style="color:#f56a00; background-color:#fde3cf;"></nz-avatar>
      <span class="user-name hidden-mobile">{{ user?.name }}</span>
      <div (click)="signOut()" class="alain-default__nav-item ant-menu-item">
        <i nz-icon nzType="logout"></i>
      </div>
    </div>
  </nz-header>
  <nz-layout>
    <nz-sider (nzCollapsedChange)="collapsedChanged($event)" *ngIf="!isHide"
              [nzCollapsed]="isCollapsed"
              nzCollapsible>
      <ul [nzInlineCollapsed]="isCollapsed" [nzMode]="isCollapsed ? 'vertical' : 'inline'" nz-menu
          style="height:100%">

        <ng-container *ngFor="let sub of menusItems$ | async | values:'seq'">
          <li *ngIf="sub.active" nz-submenu>
          <span title><i [nzType]="sub.icon" nz-icon></i>
            <span class="nav-text">{{ sub.text }}</span>
          </span>
            <ul *ngIf="sub.subMenus">
              <ng-container *ngFor="let i of sub.subMenus | values:'seq'">
                <li *ngIf="i.active" [routerLink]="buildLink(sub.link, i.link)"
                    nz-menu-item
                    routerLinkActive="ant-menu-item-selected">
                  {{  i.text }}
                </li>
              </ng-container>
            </ul>
          </li>
        </ng-container>

      </ul>
    </nz-sider>
    <nz-content>
      <nz-affix>
        <div class="alain-default__content-title">
          <ng-container #affixContent></ng-container>
        </div>
      </nz-affix>
      <div class="main-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>

<div *ngIf="isCollapsed$ | async"></div>
